<template>
    <div>
        <div>
            <el-dialog :visible.sync="dialogVisible" width="60%">
                EDIT
                <b-form-group label="Benchmarking Name:" label-for="filterInput">
                    <b-form-input id="filterInput" v-model="standardName" type="text" required placeholder="Benchmarking Name" />
                </b-form-group>
                <br>

                <!-- Mother Form -->
                <div class="flexbox flex-vertical-center sm-margin">
                    <label class="sm-side-margin" for="inlineFormCustomSelectPref">Mother Palm: &nbsp&nbsp</label>
                    <b-form-select v-model="motherRadioSelected" class="width30" text-field="name" value-field="id" :options="fruitTypeOption" />&nbsp&nbsp
                </div>
                <!-- 				<trait-select-form
					:isEmitToParent="isEmitToParent" 
					v-on:emitTraitForms="emitTraitForms2($event, 'mother')"
				>
				</trait-select-form> -->
                <trait-select-form
                    :is-emit-to-parent="isEmitToParent" 
                    :is-emit-edit-to-parent.sync="isEmitEditToParent"
                    :edit-traits-info="(editStandardInfo.motherBenchmark||{}).benchmarkTraits || ''"
                    @updateForm="emitTraitForms2($event)"
                />
                <br>
                <br>

                <!-- Father Form -->
                <div class="flexbox flex-vertical-center sm-margin">
                    <label class="sm-side-margin" for="inlineFormCustomSelectPref">Father Palm: &nbsp&nbsp</label>
                    <b-form-select v-model="fatherRadioSelected" class="width30" text-field="name" value-field="id" :options="fruitTypeOption" />&nbsp&nbsp
                </div>
                <!-- 				<trait-select-form
					:isEmitToParent="isEmitToParent"
					v-on:emitTraitForms="emitTraitForms1($event, 'father')"
				> -->
                <trait-select-form
                    :is-emit-to-parent="isEmitToParent"
                    :is-emit-edit-to-parent.sync="isEmitEditToParent"
                    :edit-traits-info="(editStandardInfo.fatherBenchmark||{}).benchmarkTraits|| ''"
                    @updateForm="emitTraitForms1($event)"
                />

                <br>
                <br>

                <!-- Child Form -->
                <div class="flexbox flex-vertical-center sm-margin">
                    <label class="sm-side-margin" for="inlineFormCustomSelectPref">Seedling Palm: &nbsp&nbsp</label>
                    <b-form-select v-model="childRadioSelected" class="width30" text-field="name" value-field="id" :options="fruitTypeOption" />&nbsp&nbsp
                </div>
                <!-- 				<trait-select-form
					:isEmitToParent="isEmitToParent"
					v-on:emitTraitForms="emitTraitForms3($event, 'child')"
				>
				</trait-select-form> -->
                <trait-select-form
                    :is-emit-to-parent="isEmitToParent"
                    :is-emit-edit-to-parent.sync="isEmitEditToParent"
                    :edit-traits-info="(editStandardInfo.childBenchmark||{}).benchmarkTraits|| ''"
                    @updateForm="emitTraitForms3($event)"
                />
                <br>
                <br>

                <v-card-actions>
                    <v-spacer />
                    <!-- <v-btn v-if="fn=='Benchmarking'" color="primary" class="v-btn-bold-color" @click.native="benchmarkNsave()">Saveaaa</v-btn> -->
                    <v-btn color="primary" class="v-btn-bold-color" @click="saveParams()">Save</v-btn>
                </v-card-actions>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    props: ["tableId","selectId","dialog", "fn", "isReloadParentDropdown", "isEdit", "selectId"],
    data () {
        return {
            standardName: "",

            fruitTypeOption: [
                { value: null, name: "No Specify Fruit Type" },
            ],

            field_options: [
                { value: null, text: "Please select an option" },
                { value: "1", text: "ht" },
                { value: "2", text: "wt" },
                { value: "3", text: "ft" },
                { value: "4", text: "bwt" },
                { value: "5", text: "swt" },
            ],
					
            // v-for Father Form
            numberFatherFilters: [ { id: 1, field_selected: "", parameter1: "", parameter2: "" }],
            nextFatherFilterId: 2,
            fatherRadioSelected: null, 
					
            // v-for Mother Form
            numberMotherFilters: [ { id: 1, field_selected: "", parameter1: "", parameter2: "" }],
            nextMotherFilterId: 2,
            motherRadioSelected: null,
					
            // v-for Child Form
            numberChildFilters: [ { id: 1, field_selected: "", parameter1: "", parameter2: "" }],
            nextChildFilterId: 2,
            childRadioSelected: null,

            // Dialog Show or not show
            dialogVisible: false,
            isEmitToParent: false,

            // Emmited Benchamrk Info
            childBenchmarkTraits: [],
            fatherBenchmarkTraits: [],
            motherBenchmarkTraits: [],

            // Check is received trait from dialog
            watcher: 0,

            // EDIT
            editStandardInfo: [],
            isEmitEditToParent: false,
        };
    },
    watch: {
        dialogVisible() {
            this.$emit("update:dialog", this.dialogVisible);
            this.$emit("update:isEdit", this.dialogVisible);
            if (this.dialogVisible == false && this.selectId) this.$emit("update:selectId", "");
        },
        dialog() {
            this.dialogVisible = this.dialog;
            $("[data-toggle=\"tooltip\"]").tooltip();
        },
        watcher() {
            if ( this.watcher == 3) {
                this.updateForm();
            }
        },
        isEdit() {
            var self = this;
            if (this.isEdit == true && this.selectId != "") {
                self.getEditStandard();
            }
        }
    },
    mounted() {
        this.getFruitType();
    },
    methods: {
        addFatherBenchmark() {
            this.numberFatherFilters.push({
				  id: this.nextFatherFilterId++,
				  field_selected: "",
				  parameter1: "",
				  parameter2: ""
            });
        },
        addMotherBenchmark() {
            this.numberMotherFilters.push({
				  id: this.nextMotherFilterId++,
				  field_selected: "",
				  parameter1: "",
				  parameter2: ""
            });
        },
        addChildBenchmark() {
            this.numberChildFilters.push({
				  id: this.nextChildFilterId++,
				  field_selected: "",
				  parameter1: "",
				  parameter2: ""
            });
        },
        deleteFatherBenchmark(index) {
            if (this.nextFatherFilterId > 2) {
                this.numberFatherFilters.splice(index, 1);
                this.nextFatherFilterId--;
            }
        },
        deleteMotherBenchmark(index) {
            if (this.nextMotherFilterId > 2) {
                this.numberMotherFilters.splice(index, 1);
                this.nextMotherFilterId--;
            }
        },
        deleteChildBenchmark(index) {
            if (this.nextChildFilterId > 2) {
                this.numberChildFilters.splice(index, 1);
                this.nextChildFilterId--;
            }
        },
        postCreateSeriesWithTrait(event) {
            this.isEmitToParent = false;
            var self = this;
            axios({
                method: "POST",
                url: "Standard/CreateWithBenchmarksAndTraits",
                data: {
					  "name": self.standardName,
					  "isPublic": true,
					  "childBenchmark": {
					    "fruitTypeId": self.childRadioSelected,
					    "benchmarkTraits": self.childBenchmarkTraits
					  },
					  "fatherBenchmark": {
					    "fruitTypeId": self.fatherRadioSelected,
					    "benchmarkTraits": self.fatherBenchmarkTraits
					  },
					  "motherBenchmark": {
					    "fruitTypeId": self.motherRadioSelected,
					    "benchmarkTraits": self.motherBenchmarkTraits
					  }
                },
            })
                .then(function (response) {
                    self.dialogVisible = false;
                    self.watcher = 0;
                    self.reloadTable("#" + self.tableId);
                    if (self.fn == "Benchmarking") {
                        self.$emit("update:isReloadParentDropdown", true);
                    }
                });
        },
        emitTraitForms1(event, name) {
            this.fatherBenchmarkTraits = event;
            this.watcher++;
        },
        emitTraitForms2(event, name) {
            this.motherBenchmarkTraits = event;
            this.watcher++;
        },
        emitTraitForms3(event, name) {
            this.childBenchmarkTraits = event;
            this.watcher++;
        },
        saveParams() {
            if (this.selectId) {
                this.dialogVisible = false;
                this.isEmitEditToParent = true;
            } 
            else {	
                this.dialogVisible = false;
                this.isEmitToParent = true;
            }
        },
        updateForm() {
            this.isEmitEditToParent = false;
            this.watcher = 0;
            alert("update");
        },
        getFruitType() {
            var self = this;
            axios({
                method: "GET",
                url: "FruitType/GetAllForDropdown",
            })
                .then(function (response) {
                    response.data.result.forEach(function(element) {
                        self.fruitTypeOption.push(element);
                    });
                });
        },
        resetForm() {
            this.fruitTypeOption = [];
        },
        getEditStandard() {
            var self = this;
            axios({
                method: "GET",
                url: "Standard/Get",
                params: {
                    Id: self.selectId
                }
            })
                .then(function (response) {
                    self.editStandardInfo = response.data.result;
                    self.fatherRadioSelected = response.data.result.fatherBenchmark.fruitTypeId;
                    self.motherRadioSelected = response.data.result.motherBenchmark.fruitTypeId;
                    self.childRadioSelected = response.data.result.childBenchmark.fruitTypeId;
                    self.standardName = response.data.result.name;
                });
        }
    }
};
</script>

<style scoped>
	.formInlineText{
		margin: 0 1rem;
	}
	.labelLine{
		margin: 8px 0;
	}
/*	.plusBtn{
		color: #007bff;
	}*/
	.radioOptions{
		display: inline-block;
		margin: 0 5px;
	}
	.radioOptions .custom-control .custom-control-label{
		font-weight: 500;
	}
	.width30{
		width: 30%;
	}
</style>


// WEBPACK FOOTER //
// src/smallComponents/StardardDialog-Edit.vue